<template>
    <el-dialog
        :visible.sync="visible"
        width="500px"
        append-to-body
        title="异常任务"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="Close">
        <el-form :model="form" label-position="top">
            <el-select v-model="form.describe" multiple filterable allow-create default-first-option placeholder="异常描述" :style="{ width: '100%' }">
                <el-option v-for="(item, idx) in suggest" :key="idx" :label="item" :value="item" />
            </el-select>
        </el-form>
        <span slot="footer">
            <el-button size="mini" @click="Close()">取 消</el-button>
            <el-button size="mini" type="primary" @click="SubmitForm()" :loading="$store.state.loading">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data () {
        return {
                        visible: false,
                        suggest: [
                '输入建议1',
                '输入建议2',
            ],
            formError: {},
            form: {
                task_id: null,
                describe: [],
            }
        }
    },
    methods: {
                Open (config)
        {
            if (config)
            {
                this.form.task_id = config.task_id
            }
            this.visible = true
        },
                Close()
        {
            this.visible = false
        },
        SubmitForm() {
            this.formError = {}
                        this.$http.post('/9api/pm/task-alarm/create', this.form).then(rps => {
                                if (rps.data.state == 'error') {
                    this.formError = rps.data.body
                }
                                if (rps.data.state == 'success') {
                    this.$emit('onChange', rps.data.body)
                    this.Close()
                }
            })
        }
    }  
}
</script>